import JustificativaFalta from "@/Pages/JustificativaFalta/index.vue";
import JustificativaFaltaPortalAluno from "@/Pages/JustificativaFalta/justificativaFaltaPortalAluno.vue";
import permitirRoles from "./guards/permitirRoles";
import ROLES_GESTOR from "./guards/rolesGestorJustificativaFalta";

const ROLES_ALUNO = ["aluno"];

const guardGestor = permitirRoles(ROLES_GESTOR);
const guardAluno = permitirRoles(ROLES_ALUNO);

export default [
  {
    path: "/justificativa-falta/index",
    name: "justificativaFalta.index",
    component: JustificativaFalta,
    beforeEnter: guardGestor,
  },
  {
    path: "/justificativa-falta/portal",
    name: "justificativaFalta.portal",
    component: JustificativaFaltaPortalAluno,
    beforeEnter: guardAluno,
  },
];
